var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.line{fill:none;stroke:currentColor;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("path",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M13.2,15.5H2.8c-1.2,0-2.3-1-2.3-2.3V2.8c0-1.2,1-2.3,2.3-2.3h10.5c1.2,0,2.3,1,2.3,2.3v10.4\n\tC15.5,14.5,14.5,15.5,13.2,15.5z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","d":"M8,8","key":2}),React.createElement("line",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","x1":"3.8","y1":"8","x2":"12.2","y2":"8","key":3}),React.createElement("line",{"stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none","x1":"8","y1":"3.8","x2":"8","y2":"12.2","key":4})]);
}

Plus.displayName = "Plus";

Plus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/plus.svg
// module id = ../icon/src/icons/plus.svg
// module chunks = 0